export const projects = [
  // --- KATEGORI: MAINTENANCE (6 Gambar) ---
  {
    title: "Pembersihan Tungku & Boiler Unit 3",
    desc: "Pekerjaan cleaning furnace dan boiler supporting untuk menjaga efisiensi perpindahan panas pada unit pembangkit.",
    category: "Maintenance",
    img: "/images/maintenance/maintenance_1.jpg",
  },
  {
    title: "Pemeliharaan Pompa Utama Industri",
    desc: "Perawatan rutin dan pengecekan komponen mekanikal pada sistem pompa sirkulasi utama.",
    category: "Maintenance",
    img: "/images/maintenance/maintenance_2.jpg",
  },
  {
    title: "Overhaul Komponen Mekanikal PLTU",
    desc: "Inspeksi mendalam dan penggantian sparepart pada mesin-mesin kritikal pembangkit listrik.",
    category: "Maintenance",
    img: "/images/maintenance/maintenance_3.jpg",
  },
  {
    title: "Perbaikan Sarana & Fasilitas PLN",
    desc: "Jasa perbaikan dan pemeliharaan gedung serta fasilitas operasional di area gardu induk.",
    category: "Maintenance",
    img: "/images/maintenance/maintenance_4.jpg",
  },
  {
    title: "Pemeliharaan Sistem Pendingin",
    desc: "Perawatan pada sistem cooling tower dan jaringan perpipaan air pendingin industri.",
    category: "Maintenance",
    img: "/images/maintenance/maintenance_5.jpg",
  },
  {
    title: "Maintenance Preventif Bulanan",
    desc: "Layanan kontrak maintenance berkala untuk memastikan zero-downtime pada alat produksi.",
    category: "Maintenance",
    img: "/images/maintenance/maintenance_6.jpg",
  },

  // --- KATEGORI: MEP (9 Gambar) ---
  {
    title: "Instalasi Fire Fighting System",
    desc: "Pemasangan jaringan pipa hydrant dan sistem fire suppression otomatis sesuai standar K3.",
    category: "MEP",
    img: "/images/mep/mep_1.jpg",
  },
  {
    title: "Sistem Kelistrikan Tegangan Menengah",
    desc: "Penarikan kabel power dan instalasi panel distribusi listrik untuk kebutuhan workshop.",
    category: "MEP",
    img: "/images/mep/mep_2.jpg",
  },
  {
    title: "Jaringan Plumbing & Sanitasi WTP",
    desc: "Instalasi sistem perpipaan air bersih dan air kotor pada proyek Water Treatment Plant.",
    category: "MEP",
    img: "/images/mep/mep_3.jpg",
  },
  {
    title: "Instalasi Pompa Dosing Kimia",
    desc: "Pemasangan unit dosing pump untuk sistem pengolahan air boiler dan cooling system.",
    category: "MEP",
    img: "/images/mep/mep_4.jpg",
  },
  {
    title: "Pemasangan Lampu Penerangan Industri",
    desc: "Instalasi sistem pencahayaan high-bay dan lampu darurat pada area operasional pembangkit.",
    category: "MEP",
    img: "/images/mep/mep_5.jpg",
  },
  {
    title: "Integrasi Sistem HVAC Workshop",
    desc: "Pengaturan sirkulasi udara dan ventilasi mekanikal pada gedung laboratorium industri.",
    category: "MEP",
    img: "/images/mep/mep_6.jpg",
  },
  {
    title: "Panel Kontrol Otomasi Industri",
    desc: "Perakitan dan instalasi panel kontrol untuk monitoring sistem mekanikal secara remote.",
    category: "MEP",
    img: "/images/mep/mep_7.jpg",
  },
  {
    title: "Pemasangan Gate Valve Utama",
    desc: "Instalasi katup tekanan tinggi pada jalur pipa transmisi fluida panas.",
    category: "MEP",
    img: "/images/mep/mep_8.jpeg",
  },
  {
    title: "Audit Energi & Sistem Listrik",
    desc: "Pengecekan beban listrik dan efisiensi sistem elektrikal pada fasilitas produksi.",
    category: "MEP",
    img: "/images/mep/mep_9.jpg",
  },

  // --- KATEGORI: PABRIKASI (6 Gambar) ---
  {
    title: "Fabrikasi Struktur Baja Ringan",
    desc: "Pembuatan rangka baja custom untuk kebutuhan gudang dan shelter alat berat.",
    category: "Pabrikasi",
    img: "/images/pabrikasi/pabrikasi_1.jpg",
  },
  {
    title: "Perbaikan Frame Slag Conveyor",
    desc: "Proses pengelasan dan penguatan struktur rangka pembawa sisa pembakaran batubara.",
    category: "Pabrikasi",
    img: "/images/pabrikasi/pabrikasi_2.jpg",
  },
  {
    title: "Fabrikasi Tangki Penampungan",
    desc: "Pembuatan vessel atau tangki penyimpanan cairan kimia dengan standar ketebalan khusus.",
    category: "Pabrikasi",
    img: "/images/pabrikasi/pabrikasi_3.jpg",
  },
  {
    title: "Pembuatan Support Pipa High-Pressure",
    desc: "Fabrikasi dudukan pipa penahan getaran untuk jalur uap tekanan tinggi.",
    category: "Pabrikasi",
    img: "/images/pabrikasi/pabrikasi_4.jpg",
  },
  {
    title: "Fabrikasi Platform & Handrail",
    desc: "Pembuatan tangga industri dan pagar pengaman jalan untuk area ketinggian.",
    category: "Pabrikasi",
    img: "/images/pabrikasi/pabrikasi_5.jpg",
  },
  {
    title: "Workshop Struktur Logam Custom",
    desc: "Layanan fabrikasi logam berdasarkan spesifikasi gambar teknik klien.",
    category: "Pabrikasi",
    img: "/images/pabrikasi/pabrikasi_6.jpg",
  },

  // --- KATEGORI: SCAFFOLDING (6 Gambar) ---
  {
    title: "Ereksi Scaffolding Area Boiler",
    desc: "Pemasangan scaffolding untuk akses inspeksi bagian dalam tungku pembakaran.",
    category: "Scaffolding",
    img: "/images/scaffolding/scaffolding_1.jpg",
  },
  {
    title: "Pemasangan Scaffolding Ringlock",
    desc: "Solusi perancah modular untuk stabilitas tinggi pada pekerjaan konstruksi berat.",
    category: "Scaffolding",
    img: "/images/scaffolding/scaffolding_2.jpg",
  },
  {
    title: "Sertifikasi Keamanan Perancah",
    desc: "Inspeksi kelayakan struktur scaffolding oleh petugas bersertifikat sebelum penggunaan.",
    category: "Scaffolding",
    img: "/images/scaffolding/scaffolding_3.jpg",
  },
  {
    title: "Scaffolding Akses Luar Gedung",
    desc: "Pemasangan scaffolding untuk pekerjaan painting dan perbaikan dinding luar gedung.",
    category: "Scaffolding",
    img: "/images/scaffolding/scaffolding_4.jpg",
  },
  {
    title: "Penyewaan Scaffolding Industri",
    desc: "Layanan logistik dan mobilisasi set perancah lengkap untuk area PLTU.",
    category: "Scaffolding",
    img: "/images/scaffolding/scaffolding_5.jpg",
  },
  {
    title: "Bongkar Pasang Perancah Cepat",
    desc: "Layanan bongkar pasang scaffolding profesional dengan mengutamakan aspek keselamatan kerja.",
    category: "Scaffolding",
    img: "/images/scaffolding/scaffolding_6.jpg",
  },
];
